export default __webpack_public_path__ + "static/media/js.7470d2bc.webp";